import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'
import { QRCodeSVG } from 'qrcode.react'
import { useTranslation } from 'react-i18next'

interface ObjectQRCodeDialogProps {
    open: boolean
    onOpenChange: (open: boolean) => void
    objectID: string | null
}

export function ObjectQRCodeDialog({
    open,
    onOpenChange,
    objectID,
}: ObjectQRCodeDialogProps) {
    const { t } = useTranslation()

    if (!objectID) return null

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[400px]">
                <DialogHeader>
                    <DialogTitle>{t('objects.qrCodeTitle', { objectID })}</DialogTitle>
                </DialogHeader>

                <div className="flex flex-col items-center justify-center py-6">
                    <div className="bg-white p-4 rounded-lg border-2 border-border">
                        <QRCodeSVG
                            value={objectID}
                            size={256}
                            level="H"
                            includeMargin={true}
                        />
                    </div>
                    <p className="mt-4 text-sm text-muted-foreground text-center">
                        {objectID}
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    )
}

